<article>
  @switch (lang) {
    @default {
      <h1>Käyttöehdot</h1>
      <p>Voimassa 28.11.2019 alkaen, päivitetty 1.1.2024</p>
    }
    @case ('en') {
      <h1>Terms of use</h1>
      <p>Valid from 28 November 2019 onwards, updated on 1 January 2024</p>
    }
    @case ('sv') {
      <h1>Användningsvillkor</h1>
      <p>I kraft från och med 28.11.2019, uppdaterade 1.1.2024</p>
    }
  }
  <ng-container>
    @for (item of termsOfUse; track item) {
      <div>
        <h2>{{ item.heading }}</h2>
        @for (paragraph of item.content; track paragraph) {
          <p [innerHTML]="paragraph"></p>
        }
      </div>
    }
  </ng-container>
</article>
